import React, { useState, Fragment } from 'react';
import classnames from "classnames";
import styles from "./TeacherModal.module.sass";
import { Controller, useForm } from 'react-hook-form';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import Button from "../../Button";
const animatedComponents = makeAnimated();

const TeacherItem = ({ teacherList, schoolId, teachers, setTeachers }) => {
  const { register, handleSubmit, control, setValue } = useForm({ defaultValues: { name: teacherList.teacher_name,
      display_name: teacherList.display_name, grade: teacherList.grade, display_grade: teacherList.display_grade } });

  const onSubmit = (data) => {
    axios
      .put(`/api/v1/educators/${teacherList.teacher_id}`,
        { data:
            {
              type: 'educators',
              id: teacherList.teacher_id,
              attributes: {
                name: data.name,
                display_name: data.display_name,
                grade: data.grade,
                display_grade: data.display_grade,
                student_id: data.student_id?.value,
                school_id: schoolId,
              }
            }
        })
      .then((data) => {
        const updatedTeacherList = teachers.map((teacher) => {
          if (teacher.teacher_id === teacherList.teacher_id) {
            return data.data.data
          } else {
            return teacher
          }
        })
        
        setTeachers(updatedTeacherList)

        toast.success("Teacher successfully updated", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
  }

  const formatStudents = () => {
    const emptyStudent = { value: '', label: 'Remove' }

    const formattedStudents = teacherList.teachers.map(student => ({ value: student.id, label: student.name }))

    return (
      [emptyStudent, ...formattedStudents]
    )
  }

  const defaultValue = () => {
    const studentRecord =  formatStudents().find(s => s.value === teacherList.student_id);

    return (
      { value: teacherList.student_id, label: studentRecord && studentRecord.label }
    )
  }

  const renderEdit = () => {
    return (
      <>
        <td>
          <form className={styles.form} onBlur={handleSubmit(onSubmit)}>
            <input
              className={styles.input}
              {...register("name")}
            />
          </form>
        </td>
        <td>
          {teacherList.student_count}
        </td>
        {/* Blank before picture day rather than a hard 0, which reads as
            "nobody showed up" when the shoot simply hasn't happened. */}
        <td>
          {teacherList.photographed_count > 0 ? teacherList.photographed_count : '\u2014'}
        </td>
        <td>
          <form className={styles.form} onBlur={handleSubmit(onSubmit)}>
            <input
              className={styles.input}
              {...register("display_name")}
            />
          </form>
        </td>
        <td>
          <form className={styles.form} onBlur={handleSubmit(onSubmit)}>
            <input
              className={styles.input}
              {...register("grade")}
            />
          </form>
        </td>
        <td>
          <form className={styles.form} onBlur={handleSubmit(onSubmit)}>
            <input
              className={styles.input}
              {...register("display_grade")}
            />
          </form>
          {/* The stored value is what the class picture prints, so it is what
              is shown. When this year's students say otherwise, say so here
              rather than quietly displaying an unsaved value -- Rescan Grades
              writes both fields. */}
          {teacherList.grade_needs_rescan && (
            <div
              className={styles.rescanHint}
              title="This year's students scan as a different grade. Press Rescan Grades to store it."
            >
              students scan as {teacherList.scanned_display_grade || teacherList.grade}
            </div>
          )}
        </td>
        <td>
          <form className={styles.form} onChange={handleSubmit(onSubmit)}>
            <Controller
              control={control}
              defaultValue={defaultValue()}
              name="student_id"
              render={({ field, value, onChange }) => (
                <Select
                  {...field}
                  onChange={(e) => { setValue('student_id', e); handleSubmit(onSubmit)() }}
                  className="basic-single"
                  components={animatedComponents}
                  defaultValue={defaultValue()}
                  options={formatStudents()}
                  name="student_id"
                  value={formatStudents().find(s => s.value === value)}
                />)}
            />
          </form>
        </td>
        <br/>
        {/*<Button*/}
        {/*  classes={styles.submit}*/}
        {/*  variant='submit'*/}
        {/*>*/}
        {/*  Save*/}
        {/*</Button>*/}
      </>
    )
  }

  return (
    <Fragment>

      {/*<a href={`${url}?teacher_id=${teacherList.teacher_id}`}*/}
      {/*   target="_blank"*/}
      {/*   key={teacherList.teacher_id}*/}
      {/*   className={styles.teacherName}>*/}
      {/*  {teacherList.teacher_name || 'No teacher name entered'}*/}
      {/*</a>*/}
      {/*<p className={styles.studentsCount}>Number of students: {teacherList.student_count}</p>*/}

      {renderEdit()}
    </Fragment>
  )
};

export default TeacherItem;
